import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconSmileChat = ({
  className,
  height,
  width,
  fill
}: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 58 48'
    fill={fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.99121 0.946411C2.33436 0.946411 0.991211 2.28956 0.991211 3.94641V35.8362C0.991211 37.4931 2.33436 38.8362 3.99121 38.8362H37.9191V47.2921C37.9191 47.7109 38.4032 47.9442 38.7308 47.6831L55.9776 33.9362C56.6918 33.367 57.1078 32.5035 57.1078 31.5903V3.94641C57.1078 2.28956 55.7646 0.946411 54.1078 0.946411H3.99121ZM22.6138 11.2173C22.6138 13.0583 21.1215 14.5507 19.2805 14.5507C17.4396 14.5507 15.9472 13.0583 15.9472 11.2173C15.9472 9.3764 17.4396 7.88401 19.2805 7.88401C21.1215 7.88401 22.6138 9.3764 22.6138 11.2173ZM39.2805 14.5507C41.1215 14.5507 42.6138 13.0583 42.6138 11.2173C42.6138 9.3764 41.1215 7.88401 39.2805 7.88401C37.4396 7.88401 35.9472 9.3764 35.9472 11.2173C35.9472 13.0583 37.4396 14.5507 39.2805 14.5507ZM17.243 21.9629C16.462 21.1818 15.1956 21.1818 14.4146 21.9629C13.6335 22.7439 13.6335 24.0103 14.4146 24.7913C21.7044 32.0811 36.4763 32.0811 43.7661 24.7913C44.5471 24.0103 44.5471 22.7439 43.7661 21.9629C42.985 21.1818 41.7187 21.1818 40.9376 21.9629C35.2099 27.6906 22.9707 27.6906 17.243 21.9629Z'
      fill='black'
    />
  </svg>
)

export default Icon(IconSmileChat)
